import { render, staticRenderFns } from "./VueHover.vue?vue&type=template&id=5ea3e322&"
import script from "./VueHover.vue?vue&type=script&lang=js&"
export * from "./VueHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports